import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class LegendItemAPI extends ComponentAPI {
    /**
     * Gets the color property.
     */
    getColor() {
        return this.state.color;
    }
    /**
     * Sets the color property.
     *
     * @param color - color value.
     */
    setColor(color) {
        this.setState({ color });
    }
    /**
     * Checks if the label is hidden.
     */
    isHideLabel() {
        return Boolean(this.state.hideLabel);
    }
    /**
     * Sets the hide label property.
     *
     * @param hideLabel - If it should hide the label.
     */
    setHideLabel(hideLabel) {
        this.setState({ hideLabel });
    }
    /**
     * Gets the icon property.
     */
    getIcon() {
        return this.state.icon;
    }
    /**
     * Sets the icon property.
     *
     * @param icon - Icon source or element.
     */
    setIcon(icon) {
        this.setState({ icon });
    }
    /**
     * Gets the label property.
     */
    getLabel() {
        return this.state.label;
    }
    /**
     * Sets the label property.
     *
     * @param label - Label value.
     */
    setLabel(label) {
        this.setState({ label });
    }
    /**
     * Gets the size property.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Sets the size property.
     *
     * @param size - Size value.
     */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Gets the value property.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the value property.
     *
     * @param value - The new value.
     */
    setValue(value) {
        this.setState({ value });
    }
}
export { LegendItemAPI, };
//# sourceMappingURL=legend-item-api.js.map